import React, { useCallback, useEffect, useState } from 'react'
import { Field, Form, Formik } from 'formik'
import { AppBar, Button, Grid, IconButton, Tab, Tabs } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'
import Table from '../../../components/Table/Table'
import { IoReload } from 'react-icons/io5'
import { MdContactPhone, MdDelete } from 'react-icons/md'
import { SiOpenstreetmap } from 'react-icons/si'

export const Cadastro = ({ objeto, voltar }) => {
  const [tabSelected, setTabSelected] = useState('endereco')
  const [habCrud, setHabCrud] = useState(undefined)
  const [listaEndereco, setListaEndereco] = useState([])
  const [listaContato, setListaContato] = useState([])
  const [enderecoSelecionado, setEnderecoSelecionado] = useState([])
  const [tela, setTela] = useState('lista')

  const initialValues = {
    cdCpf: objeto?.[0] || undefined,
    dsNome: objeto?.[1] || undefined,
    tpPessoa: objeto?.[2] || undefined,
    tpSexo: objeto?.[3] || undefined,
    tpEstadoCivil: objeto?.[4] || undefined,
    dtNascimento: objeto?.[5] || undefined,
    dsNacionalidade: objeto?.[6] || undefined,
    dsNaturalidade: objeto?.[7] || undefined,
    nrRg: objeto?.[8] || undefined,
    nrCnh: objeto?.[9] || undefined,
    tpCategoriaCnh: objeto?.[10] || undefined,
    nrPassaporte: objeto?.[11] || undefined,
    dtExclusao: objeto?.[12] || undefined,
  }

  const salva = async (values) => {
    console.log('dados', values)
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  const getContato = useCallback(() => {
    metodoPrograma('getPessoa', { cdCpf: objeto?.[0] }).then((res) => {
      if (res.status) {
        if (res.listaEndereco) {
          setListaEndereco(res.listaEndereco)
        } else {
          setListaEndereco([])
        }
        if (res.listaContato) {
          setListaContato(res.listaContato)
        } else {
          setListaContato([])
        }
      }
    })
  }, [objeto])

  useEffect(() => {
    getContato()
  }, [getContato])

  const handleClick = (_, linha) => {
    setEnderecoSelecionado(linha)
    setTela('opcoes')
  }

  const excluiEndereco = (idEmpresa) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja ativar/inativar este registro?',
      )
    )
      return
    await metodoPrograma('excluiEndereco', { idEmpresa })
    await getContato()
  }

  const excluiContato = (idEmpresa) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja ativar/inativar este registro?',
      )
    )
      return
    await metodoPrograma('excluiContato', { idEmpresa })
    await getContato()
  }

  console.log('enderecoSelecionado', enderecoSelecionado)
  console.log('tela', tela)
  console.log('habCrud', habCrud)

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="cdCpf"
                label="CPF"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpPessoa"
                label="Tipo de PEssoa"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpSexo"
                label="Sexo"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dtNascimento"
                label="Nascimento"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpEstadoCivil"
                label="Estado Civíl"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                name="dsNacionalidade"
                label="Nacionalidade"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                name="dsNaturalidade"
                label="Naturalidade"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrRg"
                label="RG"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrCnh"
                label="CNH"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpCategoriaCnh"
                label="Categoria CNH"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrPassaporte"
                label="Número Passaporte"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <AppBar position="static" variant="outlined" color="default">
                  <Tabs
                    value={tabSelected}
                    onChange={(e, value) => {
                      setTabSelected(value)
                      setHabCrud(undefined)
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    <Tab
                      icon={<SiOpenstreetmap />}
                      label="Endereços"
                      value="endereco"
                    />
                    <Tab
                      icon={<MdContactPhone />}
                      label="Contatos"
                      value="contato"
                    />
                  </Tabs>
                </AppBar>
              </Grid>
            </Grid>
            {tabSelected === 'contato' && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Table
                    dados={listaContato}
                    head={['CPF', 'Nome', 'Inclusão', 'Exclusão', '']}
                    line={(l) => [l[0], l[1], l[2], l[3], '']}
                    onClick={handleClick}
                    columnOptions={[
                      {
                        alias: 4,
                        customJsx: ({ linhaOriginal }) => (
                          <IconButton
                            size="small"
                            onClick={excluiContato(linhaOriginal[0])}
                          >
                            {linhaOriginal[4] ? <IoReload /> : <MdDelete />}
                          </IconButton>
                        ),
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            )}
            {tabSelected === 'endereco' && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Table
                    dados={listaEndereco}
                    head={['CPF', 'Nome', 'Inclusão', 'Exclusão', '']}
                    line={(l) => [l[0], l[1], l[2], l[3], '']}
                    onClick={handleClick}
                    columnOptions={[
                      {
                        alias: 4,
                        customJsx: ({ linhaOriginal }) => (
                          <IconButton
                            size="small"
                            onClick={excluiEndereco(linhaOriginal[0])}
                          >
                            {linhaOriginal[4] ? <IoReload /> : <MdDelete />}
                          </IconButton>
                        ),
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
